import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pulse-agent" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.showIcon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: $options.icon,
          stroke: $options.color,
          size: $props.size
        }, null, 8 /* PROPS */, ["icon", "stroke", "size"]))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString($props.label), 1 /* TEXT */)
  ]))
}